import { render, staticRenderFns } from "./SearchBoxForAPNICStaff.vue?vue&type=template&id=476e02e4&scoped=true&"
import script from "./SearchBoxForAPNICStaff.vue?vue&type=script&lang=js&"
export * from "./SearchBoxForAPNICStaff.vue?vue&type=script&lang=js&"
import style0 from "./SearchBoxForAPNICStaff.vue?vue&type=style&index=0&id=476e02e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476e02e4",
  null
  
)

export default component.exports